import { styled } from "@mui/material";

export const InputWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: "relative",
  "label": {
    fontSize: 11,
    color: theme.palette.text.secondary,
    paddingBottom: 2
  },
  "input, textarea": {
    backgroundColor: "#2C3748",
    border: "none",
    paddingLeft: 10,
    paddingTop: "0.6em",
    paddingBottom: "0.6em",
    lineHeight: "1.5em",
    outline: "none",
    color: "white",
    borderRadius: 4,
    fontFamily: theme.typography.fontFamily,
    fontSize: 12,
    resize: "none",
    boxSizing: "border-box",
    display: "block"
  },
  ".textarea-wrapper": {
    backgroundColor: "#2C3748",
    paddingLeft: 8,
    paddingRight: 4,
    borderRadius: 4
  },
  "textarea": {
    paddingLeft: 0,
    background: "none",
    borderRadius: 0,
    width: "100%"
  }
}))